import React from 'react'

function Ingredients({ foodDetail }) {






    return (
        <div>
            <h2 className="mb-2 text-lg font-bold text-gray-900 dark:text-white">Ingredients:</h2>
            <ol className="max-w-md space-y-1 text-gray-500 list-decimal list-inside dark:text-gray-400">

                {
                    foodDetail.strIngredient1 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient1}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure1}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient2 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient2}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure2}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient3 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient3}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure3}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient4 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient4}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure4}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient5 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient5}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure5}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient6 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient1}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure1}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient7 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient6}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure7}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient8 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient8}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure8}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient9 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient9}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure9}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient10 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient10}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure10}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient11 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient11}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure11}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient12 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient12}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure12}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient13 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient13}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure13}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient14 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient14}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure14}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient15 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient15}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure15}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient16 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient16}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure16}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient17 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient17}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure17}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient18 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient18}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure18}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient19 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient19}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure19}</span>
                    </li>
                }
                {
                    foodDetail.strIngredient20 && <li>
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strIngredient20}</span> : <span className="font-semibold text-gray-900 dark:text-white">
                            {foodDetail.strMeasure20}</span>
                    </li>
                }
            </ol>
        </div>
    )
}

export default Ingredients